import { render } from "./HeaderLanguageSelector.vue?vue&type=template&id=9761f3a2"
import script from "./HeaderLanguageSelector.vue?vue&type=script&lang=js"
export * from "./HeaderLanguageSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/HeaderLanguageSelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9761f3a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9761f3a2', __exports__)) {
    api.reload('9761f3a2', __exports__)
  }
  
  module.hot.accept("./HeaderLanguageSelector.vue?vue&type=template&id=9761f3a2", () => {
    api.rerender('9761f3a2', render)
  })

}


export default __exports__